<template>
  <div class="re-listening">
    <div class="re-book text-center mb-16">
      <h1 class="dastnevis py-5">داستان کتاب را بشنویم</h1>
      <div class="py-9" v-if="book">
        <v-img
          width="150"
          class="re-rounded re-shadow mx-auto my-8"
          :src="'https://dl.pirls.ir/app/audiocovers/' + book._id + '.jpg'"
        />
        <vue-plyr>
          <audio playsinline>
            <source
              :src="'https://dl.pirls.ir/app/sound/' + book._id + '.mp3'"
              type="audio/mp3"
            />
          </audio>
        </vue-plyr>
      </div>
    </div>

    <MenuComponent :book-id="this.$route.params.id" state="listening" />
  </div>
</template>

<script>
import MenuComponent from "./Menu.vue";
export default {
  name: "listening-component",
  components: { MenuComponent },
  data() {
    return {
      book: null
    };
  },
  created() {
    this.getBook();
  },
  methods: {
    getBook() {
      this.$api.get("/book/" + this.$route.params.id).then((res) => {
        this.book = res.data.book;
      });
    }
  }
};
</script>

<style>
.re-audio {
  width: 100%;
}
</style>
